export default "__VITE_ASSET__BoEe7kZk__"